<template>
  <div>
    <v-row v-if="loading">
      <v-col>
        <v-progress-circular indeterminate />
      </v-col>
    </v-row>
    <v-row v-else>
      <v-col cols="12" sm="6">
        <v-card
          flat
          class="px-4 py-3"
          :key="reRender"
          :class="!isEditCard1 ? 'mouse-cursor' : ''"
        >
          <div class="text-start">
            <v-row class="py-3">
              <v-col>
                <v-row>
                  <v-col
                    cols="5"
                    sm="4"
                    xl="3"
                    class="subtitle-1 textLight--text mouse-cursor"
                  >
                    <!-- {{ key.charAt(0).toUpperCase() + key.slice(1) }} -->
                    <span>{{ $t("user.gender") }}</span>
                  </v-col>
                  <v-col
                    cols="7"
                    sm="8"
                    xl="9"
                    class="subtitle-1 textLight--text"
                    style="opacity: 0.5"
                  >
                    <v-select
                      :readonly="!isEditCard1"
                      append-icon=""
                      hide-details
                      v-model="card1.gender"
                      :items="gender"
                      item-text="text"
                      item-value="value"
                      dense
                      class="rounded-md text-body-2 ma-0 hide-underline"
                    />
                  </v-col>
                </v-row>
                <v-divider class="my-3"></v-divider>

                <v-row>
                  <v-col
                    cols="5"
                    sm="4"
                    xl="3"
                    class="subtitle-1 textLight--text mouse-cursor"
                  >
                    <span>{{ $t("user.dob") }}</span>
                  </v-col>
                  <v-col
                    cols="7"
                    sm="8"
                    xl="9"
                    class="subtitle-1 textLight--text"
                    style="opacity: 0.5"
                  >
                    <v-menu
                      :disabled="!isEditCard1"
                      v-model="menu"
                      :close-on-content-click="false"
                      transition="scale-transition"
                      offset-y
                      max-width="290px"
                      min-width="auto"
                    >
                      <template
                        v-slot:activator="{ on, attrs }"
                        rules="required"
                      >
                        <v-text-field
                          class="hide-underline"
                          hide-details
                          v-model="card1.dob"
                          dense
                          readonly
                          v-bind="attrs"
                          v-on="on"
                        />
                      </template>

                      <v-date-picker
                        color="textLight"
                        v-model="date"
                        no-title
                        @input="menu = false"
                      />
                    </v-menu>
                  </v-col>
                </v-row>
                <v-divider class="my-3"></v-divider>

                <v-row>
                  <v-col
                    cols="5"
                    sm="4"
                    xl="3"
                    class="subtitle-1 textLight--text mouse-cursor"
                  >
                    <span>{{ $t("user.email") }}</span>
                  </v-col>
                  <v-col
                    cols="7"
                    sm="8"
                    xl="9"
                    class="subtitle-1 textLight--text"
                    style="opacity: 0.5"
                  >
                    <Editable2
                      v-model="card1.email"
                      :isEdit="isEditCard1"
                      :validateRules="'email'"
                      ref="email"
                    />
                  </v-col>
                </v-row>
                <v-divider class="my-3"></v-divider>

                <v-row>
                  <v-col
                    cols="5"
                    sm="4"
                    xl="3"
                    class="subtitle-1 textLight--text mouse-cursor"
                  >
                    <span>{{ $t("user.mobile") }}</span>
                  </v-col>

                  <v-col
                    cols="7"
                    sm="8"
                    xl="9"
                    class="subtitle-1 textLight--text"
                    style="opacity: 0.5"
                  >
                    <Editable2
                      v-model="card1.mobile"
                      :isEdit="isEditCard1"
                      :validateRules="'numeric|max:10'"
                      ref="mobile"
                    />
                  </v-col>
                </v-row>
                <v-divider class="my-3"></v-divider>

                <v-row>
                  <v-col
                    cols="5"
                    sm="4"
                    xl="3"
                    class="subtitle-1 textLight--text mouse-cursor"
                  >
                    <span>{{ $t("user.civilIdOrPassport") }}</span>
                  </v-col>

                  <v-col
                    cols="7"
                    sm="8"
                    xl="9"
                    class="subtitle-1 textLight--text"
                    style="opacity: 0.5"
                  >
                    <Editable2
                      v-model="card1.civilIdOrPassport"
                      :isEdit="isEditCard1"
                    />
                  </v-col>
                </v-row>
                <v-divider class="my-3"></v-divider>

                <v-row>
                  <v-col
                    cols="5"
                    sm="4"
                    xl="3"
                    class="subtitle-1 textLight--text mouse-cursor"
                  >
                    <span>{{ $t("user.bloodGroup") }}</span>
                  </v-col>

                  <v-col
                    cols="7"
                    sm="8"
                    xl="9"
                    class="subtitle-1 textLight--text"
                    style="opacity: 0.5"
                  >
                    <Editable2
                      v-model="card1.bloodGroup"
                      :isEdit="isEditCard1"
                    />
                  </v-col>
                </v-row>
                <v-divider class="my-3"></v-divider>

                <v-row>
                  <v-col
                    cols="5"
                    sm="4"
                    xl="3"
                    class="subtitle-1 textLight--text mouse-cursor"
                  >
                    <span>{{ $t("user.nationality") }}</span>
                  </v-col>

                  <v-col
                    cols="7"
                    sm="8"
                    xl="9"
                    class="subtitle-1 textLight--text"
                    style="opacity: 0.5"
                  >
                    <v-autocomplete
                      :readonly="!isEditCard1"
                      append-icon=""
                      hide-details
                      v-model="card1.nationality"
                      :items="countries"
                      item-value="name"
                      item-text="name"
                      dense
                      class="rounded-md text-body-2 ma-0 hide-underline"
                    >
                      <template v-slot:item="{ item }">
                        <div class="d-flex justify-start">
                          {{ item.name }}
                        </div>
                      </template>
                    </v-autocomplete>
                  </v-col>
                </v-row>
                <v-divider class="my-3"></v-divider>

                <v-row>
                  <v-col
                    cols="5"
                    sm="4"
                    xl="3"
                    class="subtitle-1 textLight--text mouse-cursor"
                  >
                    <span>{{ $t("user.department") }}</span>
                  </v-col>

                  <v-col
                    cols="7"
                    sm="8"
                    xl="9"
                    class="subtitle-1 textLight--text"
                    style="opacity: 0.5"
                  >
                    <Editable2
                      v-model="card1.department"
                      :isEdit="isEditCard1"
                    />
                  </v-col>
                </v-row>
                <v-divider class="my-3"></v-divider>

                <v-row>
                  <v-col
                    cols="5"
                    sm="4"
                    xl="3"
                    class="subtitle-1 textLight--text mouse-cursor"
                  >
                    <span>
                      {{ $t("user.designation") }}
                    </span>
                  </v-col>
                  <v-col
                    cols="7"
                    sm="8"
                    xl="9"
                    class="subtitle-1 textLight--text"
                    style="opacity: 0.5"
                  >
                    <Editable2
                      v-model="card1.designation"
                      :isEdit="isEditCard1"
                    />
                  </v-col>
                </v-row>

                <v-row
                  v-if="
                    userData.subRoles && userData.subRoles.length
                      ? userData.subRoles.find(x => x.name === 'TRAINER')
                      : false
                  "
                >
                  <v-col
                    cols="5"
                    sm="4"
                    xl="3"
                    class="subtitle-1 textLight--text mouse-cursor"
                  >
                    <span> {{ $t("user.signature") }} </span>
                  </v-col>
                  <v-col
                    cols="7"
                    sm="8"
                    xl="9"
                    class="subtitle-1 textLight--text"
                    :style="!isEditCard1 ? 'pointer-events: none' : ''"
                  >
                    <image-uploader
                      id="training-image"
                      :maxWidth="1024"
                      :maxHeight="512"
                      :quality="0.9"
                      :autoRotate="true"
                      outputFormat="blob"
                      :preview="false"
                      :capture="false"
                      accept="image/*"
                      doNotResize="['gif', 'svg']"
                      @input="onFileSelect"
                    >
                     <label for="training-image" slot="upload-label">

                    <!--  EXISTING SIGNATURE -->
                       <v-img
                       v-if="card1.signature && !signatureImageUrl"
                       :src="getImage(card1.signature)"
                       :max-height="signatureImageHeight"
                       contain
                       style="border-radius: 7px; margin-bottom: 10px"
                      />

                      <!--  NEW PREVIEW WITH CANCEL -->
                        <v-container
                          v-if="signatureImageUrl"
                          fluid
                          class="pa-0"
                          style="position: relative; margin-bottom: 10px"
                        >
                          <v-img
                            :src="signatureImageUrl"
                            :max-height="signatureImageHeight"
                            contain
                             style="border-radius: 7px"
                             />

                         <!--  CANCEL ONLY HERE -->
                          <div style="position: absolute; bottom: 5px; right: 5px">
                            <v-btn
                              small
                              color="error"
                              min-width="80"
                              class="rounded-1"
                              @click.prevent="cancelMediaSelection"
                            >
                             Cancel
                            </v-btn>
                          </div>
                        </v-container>

                   <!--  ALWAYS SHOW UPLOAD -->
                     <div
                        class="textLight--text text-center hand-cursor"
                          style="
                            border: 2px dashed #ccc;
                            border-radius: 7px;
                            padding: 10px;
                            opacity: 0.7;
                            "
                             >
                          <v-icon size="30">mdi-upload</v-icon>
                          <div>Upload / Change Signature</div>
                             </div>

                      </label>
                    </image-uploader>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </div>
          <float-btn
            v-if="
              !loading &&
              (havePermissionUpdateEmployee || isAuthenticatedTrainer)
            "
            :isEdit="isEditCard1"
            @save="saveCard1Items"
            @edit="isEditCard1 = true"
            :bottom="true"
            :align="'right'"
            :loading="savingData1"
          />
        </v-card>
      </v-col>

      <v-col cols="12" sm="6">
        <v-card
          flat
          class="px-4 py-3"
          :key="reRender"
          :class="!isEditCard2 ? 'mouse-cursor' : ''"
        >
          <div class="text-start">
            <v-row class="py-3">
              <v-col>
                <v-row>
                  <v-col
                    cols="5"
                    sm="4"
                    xl="3"
                    class="subtitle-1 textLight--text mouse-cursor"
                  >
                    <span>
                      {{ $t("user.linkedin") }}
                    </span>
                  </v-col>
                  <v-col
                    cols="7"
                    sm="8"
                    xl="9"
                    class="subtitle-1 textLight--text"
                    style="opacity: 0.5"
                  >
                    <Editable2
                      v-model="card2.linkedin"
                      :isEdit="isEditCard2"
                      :validateRules="'url'"
                      ref="linkedin"
                    />
                  </v-col>
                </v-row>
                <!-- <v-divider class="my-3" />

                <v-row>
                  <v-col
                    cols="5"
                    sm="4"
                    xl="3"
                    class="subtitle-1 textLight--text mouse-cursor"
                  >
                    <span>{{ $t("user.twitter") }}</span>
                  </v-col>
                  <v-col
                    cols="7"
                    sm="8"
                    xl="9"
                    class="subtitle-1 textLight--text"
                    style="opacity: 0.5"
                  >
                    <Editable2
                      v-model="card2.twitter"
                      :isEdit="isEditCard2"
                      :validateRules="'url'"
                      ref="twitter"
                    />
                  </v-col>
                </v-row>
                <v-divider class="my-3" />

                <v-row>
                  <v-col
                    cols="5"
                    sm="4"
                    xl="3"
                    class="subtitle-1 textLight--text mouse-cursor"
                  >
                    <span>
                      {{ $t("user.facebook") }}
                    </span>
                  </v-col>
                  <v-col
                    cols="7"
                    sm="8"
                    xl="9"
                    class="subtitle-1 textLight--text"
                    style="opacity: 0.5"
                  >
                    <Editable2
                      v-model="card2.facebook"
                      :isEdit="isEditCard2"
                      :validateRules="'url'"
                      ref="facebook"
                    />
                  </v-col>
                </v-row>
                <v-divider class="my-3" />

                <v-row>
                  <v-col
                    cols="5"
                    sm="4"
                    xl="3"
                    class="subtitle-1 textLight--text mouse-cursor"
                  >
                    <span>
                      {{ $t("user.instagram") }}
                    </span>
                  </v-col>
                  <v-col
                    cols="7"
                    sm="8"
                    xl="9"
                    class="subtitle-1 textLight--text"
                    style="opacity: 0.5"
                  >
                    <Editable2
                      v-model="card2.instagram"
                      :isEdit="isEditCard2"
                      :validateRules="'url'"
                      ref="instagram"
                    />
                  </v-col>
                </v-row>
                <v-divider class="my-3" />

                <v-row>
                  <v-col
                    cols="5"
                    sm="4"
                    xl="3"
                    class="subtitle-1 textLight--text mouse-cursor"
                  >
                    <span>
                      {{ $t("user.coursera") }}
                    </span>
                  </v-col>
                  <v-col
                    cols="7"
                    sm="8"
                    xl="9"
                    class="subtitle-1 textLight--text"
                    style="opacity: 0.5"
                  >
                    <Editable2
                      v-model="card2.coursera"
                      :isEdit="isEditCard2"
                      :validateRules="'url'"
                      ref="coursera"
                    />
                  </v-col>
                </v-row> -->
              </v-col>
            </v-row>
          </div>
          <float-btn
            v-if="
              !loading &&
              (havePermissionUpdateEmployee || isAuthenticatedTrainer)
            "
            :isEdit="isEditCard2"
            @save="saveCard2Items"
            @edit="isEditCard2 = true"
            :bottom="true"
            :align="'right'"
            :loading="savingData2"
          />
        </v-card>
      </v-col>
    </v-row>

    <v-snackbar v-model="snackbarError" timeout="3000" color="error">
      {{ snackbarErrorMessage || $t("somethingWentWrong") }}

      <template v-slot:action="{ attrs }">
        <v-btn
          color="primary"
          text
          v-bind="attrs"
          @click="
            snackbarError = false;
            snackbarErrorMessage = null;
          "
        >
          {{ $t("close") }}
        </v-btn>
      </template>
    </v-snackbar>
    <CropperModal ref="cropperModal" @croppedData="croppedData" />
  </div>
</template>

<script>
import Editable2 from "../../../core-module/components/ContentEditable2.vue";
import FloatBtn from "./FloatBtn.vue";
import CropperModal from "../../../core-module/components/CropperModal.vue";

import { updateEmployee } from "../../methods/updateEmployee";
import { hasPermission, authUser } from "@/app/user-module/helpers/authHelper";

import countryList from "../../../core-module/assets/json/countryList.json";

export default {
  components: {
    Editable2,
    FloatBtn,
    CropperModal,
  },
  props: {
    userData: {
      type: Object,
      default: () => {},
      required: true,
    },
    loading: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      snackbarError: false,
      snackbarErrorMessage: null,
      card1: {
        gender: "",
        dob: "",
        email: "",
        mobile: "",
        designation: "",
        civilIdOrPassport: "",
        bloodGroup: "",
        nationality: "",
        department: "",
        signature: "",
      },
      card1Error: {
        email: null,
        mobile: null,
      },

      card2: {
        linkedin: "",
        twitter: "",
        facebook: "",
        instagram: "",
        coursera: "",
      },
      card2Error: {
        linkedin: null,
        twitter: null,
        facebook: null,
        instagram: null,
        coursera: null,
      },

      date: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10),
      menu: false,
      gender: [
        { text: "Male", value: "MALE" },
        { text: "Female", value: "FEMALE" },
        { text: "Other", value: "OTHER" },
      ],

      userProfile: null,
      savingData1: false,
      savingData2: false,
      isEditCard1: false,
      isEditCard2: false,
      reRender: 0,
      countries: countryList,
      signatureImage: null,
      signatureImageUrl: null,
    };
  },
  computed: {
    havePermissionUpdateEmployee() {
      return hasPermission({
        currentRole: this.$store.state.authenticatedUserRole,
        currentPermissions: this.$store.state.authenticatedUserPermissions,
        requiredPermission: ["UPDATE_EMPLOYEE"],
        restrictOrganizationManager:
          this.$store.state.authenticatedUser?.isOrganizationManager,
      });
    },
    isAuthenticatedTrainer() {
      return authUser()?.subRoles?.find(x => x.name === "TRAINER") &&
        authUser()?._id === this.$route?.params?.userId
        ? true
        : false;
    },
    signatureImageHeight() {
      return this.$vuetify.breakpoint.xlOnly
        ? 400
        : this.$vuetify.breakpoint.lgAndUp
        ? 150
        : 250;
    },
  },

  watch: {
    date(val) {
      this.card1.dob = this.formatDate(this.date);
    },
    userData: {
      immediate: true,
      handler() {
        this.userProfile = this.userData ? this.userData : null;
        this.resetFormData();
      },
      deep: true,
    },
  },
  methods: {
    authUser,
    onFileSelect(output) {
      var reader = new FileReader();
      reader.readAsDataURL(output);
      var self = this;

      reader.onloadend = function () {
        var base64data = reader.result;
        // self.categoryInput.url = base64data;
        self.signatureImageUrl = base64data;
        self.$refs.cropperModal.show(self.signatureImageUrl);
      };
      this.signatureImage = output;
    },
    croppedData(blobData, base64Data) {
      this.signatureImage = blobData;
      this.signatureImageUrl = base64Data;
    },
    cancelMediaSelection() {
      this.signatureImage = null;
      this.signatureImageUrl = null;
      const el = document.getElementById("training-image");
      if (el) el.value = "";
    },
    resetFormData() {
      const roleKey = this.userProfile?.role?.toLowerCase();
      this.card1.gender = this.userProfile?.[roleKey]?.gender;
      this.card1.dob = this.userProfile?.[roleKey]?.dob
        ? this.$moment(parseInt(this.userProfile?.[roleKey]?.dob)).format(
            "DD/MM/YYYY"
          )
        : null;
      this.card1.email = this.userProfile?.email;
      this.card1.mobile = this.userProfile?.phone?.number;
      this.card1.designation = this.userProfile?.[roleKey]?.designation;
      this.card1.civilIdOrPassport = this.userProfile?.civilIdOrPassport;
      this.card1.bloodGroup = this.userProfile?.[roleKey]?.bloodGroup;
      this.card1.nationality = this.userProfile?.[roleKey]?.nationality;
      this.card1.department = this.userProfile?.[roleKey]?.department;
      this.card1.signature = this.userProfile?.[roleKey]?.signature;

      this.card2.linkedin =
        this.userProfile?.[roleKey]?.externalLinks?.linkedin;
      this.card2.twitter = this.userProfile?.[roleKey]?.externalLinks?.twitter;
      this.card2.facebook =
        this.userProfile?.[roleKey]?.externalLinks?.facebook;
      this.card2.instagram =
        this.userProfile?.[roleKey]?.externalLinks?.instagram;
      this.card2.coursera =
        this.userProfile?.[roleKey]?.externalLinks?.coursera;
      this.signatureImage = null;
      this.signatureImageUrl = null;
      this.reRender++;
    },
    resetCard1Error() {
      this.card1Error = {
        email: null,
        mobile: null,
      };
    },
    resetCard2Error() {
      this.card2Error = {
        linkedin: null,
        twitter: null,
        facebook: null,
        instagram: null,
        coursera: null,
      };
    },
    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },
    formatDateServer(date) {
      if (!date) return null;

      const [day, month, year] = date.split("/");
      return `${year}-${month}-${day}`;
    },

    async saveCard1Items() {
      this.resetCard1Error();
      this.snackbarErrorMessage = null;

      this.card1Error.email = (await this.$refs.email.checkIsValid())
        ? null
        : true;

      this.card1Error.mobile = (await this.$refs.mobile.checkIsValid())
        ? null
        : true;

      if (Object.values(this.card1Error).some(x => x != null)) {
        return;
      }

      this.savingData1 = true;
      this.isEditCard1 = false;

      let saveData = {
        dob: this.card1.dob ? this.formatDateServer(this.card1.dob) : null,
        gender: this.card1.gender ? this.card1.gender : null,
        designation: this.card1.designation,
        bloodGroup: this.card1.bloodGroup ? this.card1.bloodGroup : " ",
        nationality: this.card1.nationality ? this.card1.nationality : " ",
        department: this.card1.department ? this.card1.department : " ",
        user: {
          email: this.card1.email ? this.card1.email : null,
          civilIdOrPassport: this.card1.civilIdOrPassport
            ? this.card1.civilIdOrPassport
            : " ",
          phone: {
            countryCode: "+965",
            number: this.card1.mobile ? this.card1.mobile : "",
          },
        },
      };
      if (this.signatureImage instanceof Blob) {
        saveData.signature = this.signatureImage;
      }

      this.update(saveData).then(response => {
        if (response.error) {
          this.$emit("onError");
          this.resetFormData();
        } else if (response?.data) this.$emit("update");

        this.savingData1 = false;
      });
    },
    async saveCard2Items() {
      this.resetCard2Error();
      this.snackbarErrorMessage = null;

      this.card2Error.linkedin = (await this.$refs.linkedin.checkIsValid())
        ? null
        : true;

      this.card2Error.twitter = (await this.$refs.twitter.checkIsValid())
        ? null
        : true;

      this.card2Error.facebook = (await this.$refs.facebook.checkIsValid())
        ? null
        : true;

      this.card2Error.instagram = (await this.$refs.instagram.checkIsValid())
        ? null
        : true;

      this.card2Error.coursera = (await this.$refs.coursera.checkIsValid())
        ? null
        : true;

      if (Object.values(this.card2Error).some(x => x != null)) {
        return;
      }

      this.savingData2 = true;
      this.isEditCard2 = false;

      let saveData = {
        externalLinks: {
          linkedin: this.card2.linkedin,
          twitter: this.card2.twitter,
          facebook: this.card2.facebook,
          instagram: this.card2.instagram,
          coursera: this.card2.coursera,
        },
      };

      this.update(saveData).then(response => {
        if (response.error) {
          this.$emit("onError");
          this.resetFormData();
        }

        this.savingData2 = false;
      });
    },
    update(data) {
      return updateEmployee({
        id: this.userData?.employee?._id,
        input: data,
      });
    },
  },
};
</script>

<style scoped>
.hide-underline >>> .v-input__slot::before {
  border-style: none !important;
}
.hide-underline >>> .v-input__slot::after {
  border-style: none !important;
}
</style>
